// Generated by Melange

import ProseModuleCss from "./prose.module.css";
import * as Caml_option from "melange.js/caml_option.jsx";
import * as Curry from "melange.js/curry.jsx";
import * as Shared__Skeleton from "./skeleton.jsx";
import * as Stdlib__Int from "melange/int.jsx";
import * as Stdlib__Option from "melange/option.jsx";
import * as Webapi__Dom__HtmlElement from "melange-webapi/Webapi/Dom/Webapi__Dom__HtmlElement.jsx";
import * as Webapi__Dom__Node from "melange-webapi/Webapi/Dom/Webapi__Dom__Node.jsx";
import * as JsxRuntime from "react/jsx-runtime";

const css = ProseModuleCss;

function Prose(Props) {
  let html = Props.html;
  if (html !== undefined) {
    return JsxRuntime.jsx("div", {
      children: Array.prototype.slice.call(Stdlib__Option.get(Webapi__Dom__HtmlElement.ofElement(Stdlib__Option.get(Caml_option.nullable_to_opt(new DOMParser().parseFromString(html, "text/html").body)))).childNodes).map(function (node, index) {
        const match = Webapi__Dom__Node.nodeType(node);
        switch (match) {
          case /* Element */ 0 :
            const match$1 = node.nodeName;
            if (match$1 !== "A") {
              return Stdlib__Option.get(Curry._1(Webapi__Dom__HtmlElement.ofNode, node)).outerHTML;
            }
            const Key = Stdlib__Int.to_string(index);
            let tmp = {
              children: node.textContent,
              className: css.link,
              rel: "noopener",
              target: "_blank"
            };
            const tmp$1 = Stdlib__Option.bind(Curry._1(Webapi__Dom__HtmlElement.ofNode, node), (function (param) {
              return Caml_option.nullable_to_opt(param.getAttribute("href"));
            }));
            if (tmp$1 !== undefined) {
              tmp.href = Caml_option.valFromOption(tmp$1);
            }
            return JsxRuntime.jsx("a", tmp, Key);
          case /* Text */ 2 :
            return node.textContent;
          default:
            return String(node);
        }
      })
    });
  } else {
    return JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsx(Shared__Skeleton.make, {
          className: css.skeletonLine1
        }),
        JsxRuntime.jsx(Shared__Skeleton.make, {
          className: css.skeletonLine2
        }),
        JsxRuntime.jsx(Shared__Skeleton.make, {
          className: css.skeletonLine3
        }),
        JsxRuntime.jsx(Shared__Skeleton.make, {
          className: css.skeletonLine4
        })
      ]
    });
  }
}

const make = Prose;

export {
  make,
}
/* css Not a pure module */
